import Vue from 'vue';
import { Component, PropSync } from 'vue-property-decorator';
import RecipientFields from '@/components/common/RecipientFields.vue';

@Component({
    components: { RecipientFields },
})
export default class WriteCC extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @PropSync('value', { type: Object }) writeEmailData!: mail.WriteEmailData;
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    cc: string = '';
    bcc: string = '';
    cctitle: string = this.$t('W_Mail_CC').toString();
    bcctitle: string = this.$t('W_Mail_BCC').toString();

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        for (let index = 0; index < this.writeEmailData.cc.length; index++) {
            const element = this.writeEmailData.cc[index];
            if (element.value != '') {
                this.cc += element.value + ';';
            }
        }

        for (let index = 0; index < this.writeEmailData.bcc.length; index++) {
            const element = this.writeEmailData.bcc[index];
            if (element.value != '') {
                this.bcc += element.value + ';';
            }
        }
    }
}
